@for (subcontainer of subcontainerMultiple.subcontainerDuplicated; track $index) {
  <div class="concept-form__form-fields-container">
    <div class="common-section-title__gs-container-secondary"
      [id]="'group-subcontainer-'+$index">
      @if (subcontainer.references?.length) {
        <tooltip-law
          [concept]="subcontainerMultiple.concept"
          [references]="subcontainer.references"
        [type]="'group'"></tooltip-law>
      }
      @if (subcontainer.relatedInfo?.length) {
        <button class="common-button__icon-sm-background"
          pTooltip="{{'common.related-info'| afTranslate}}"
          tooltipPosition="top"
          (click)="openRelatedInfo(subcontainer.relatedInfo)">
          <i class="lf-icon-search-text common-icon__md"></i>
        </button>
      }
      <div class="common-section-title__gs-item-container">
        @if (subcontainerMultiple.subContainer?.isHighlight && $first) {
          <i class="lf-icon-important common-icon__md common-section-title__gs-icon-important"></i>
        }
        <span class="common-section-title__gs-label-text">{{subcontainer.name}}</span>
      </div>
      @if (!subcontainerMultiple.lockedSubcontainer && $first && (subcontainerMultiple.concept.conceptObjectId || isLanding) && userPermissions !=='none') {
        <button class="common-button__icon-md-background"
          (click)="duplicateSubcontainer()"
          pTooltip="{{'subcontainer-multiple.new-entry' | afTranslate}}"
          tooltipPosition="top">
          <i class="lf-icon-add-round common-icon__md"></i>
        </button>
      }@else if (!subcontainerMultiple.lockedSubcontainer && !$first && userPermissions !=='none') {
        <button class="common-button__icon-md-background"
          (click)="deleteDuplicated(subcontainer)"
          pTooltip="{{'subcontainer-multiple.delete-entry' | afTranslate}}"
          tooltipPosition="top">
          <i class="lf-icon-trash common-icon__md"></i>
        </button>
      }
      @if (!isLanding && $first && subcontainerMultiple.concept?.productTypeId !== 4 && !subcontainerMultiple.concept?.poll && userPermissions !== 'none') {
        <button-with-menu-action
          [item]="subcontainerMultiple.itemOptions"
          [buttonClass]="'common-button__icon-md-background'"
          (launchActionEmitter)="launchActionHeader($event.action, subcontainer)"></button-with-menu-action>
      }
    </div>
    @for (subField of subcontainer.fields; track $index) {
      <div>
        @if (subField.show && subField.showWithProperty && (!isLanding || (isLanding && !subcontainer.hiddenInLandings && !subField.hiddenInLandings))) {
          <field-item
            [hidden]="subField.hidden"
            [fieldInfo]="subField"
            [fieldContainer]="subcontainer"
            [evaluatedConcepts]="subcontainer.evaluatedFields"
            [evaluatedFields]="subcontainerMultiple.concept.evaluatedFields"
            [isPrivate]="subcontainerMultiple.isPrivate"
            [viewMode]="viewMode"
            (evaluatedConceptChange)="changesInEvaluatedSubContainer(subField)"
            [concept]="subcontainerMultiple.concept"
            [conceptLocked]="subcontainerMultiple.conceptLocked">
          </field-item>
        }
      </div>
    }
  </div>
}
